// Import all markdown files from content/blog as raw text
const postFiles = import.meta.glob('/src/content/blog/*.md', { 
  eager: true, 
  query: '?raw',
  import: 'default'
});

// Simple frontmatter parser (browser-compatible)
function parseFrontmatter(content) {
  const frontmatterRegex = /^---\s*\n([\s\S]*?)\n---\s*\n([\s\S]*)$/;
  const match = content.match(frontmatterRegex);
  
  if (!match) {
    return { data: {}, content };
  }
  
  const frontmatterStr = match[1];
  const bodyContent = match[2];
  
  // Parse YAML-like frontmatter
  const data = {};
  const lines = frontmatterStr.split('\n');
  
  for (const line of lines) {
    const colonIndex = line.indexOf(':');
    if (colonIndex > 0) {
      const key = line.slice(0, colonIndex).trim();
      let value = line.slice(colonIndex + 1).trim();
      
      // Remove quotes if present
      if ((value.startsWith('"') && value.endsWith('"')) || 
          (value.startsWith("'") && value.endsWith("'"))) {
        value = value.slice(1, -1);
      }
      
      data[key] = value;
    }
  }
  
  return { data, content: bodyContent };
}

// Parse a single post
function parsePost(filePath, rawContent) {
  const slug = filePath.replace('/src/content/blog/', '').replace('.md', '');
  const { data, content } = parseFrontmatter(rawContent);
  
  return {
    slug,
    title: data.title || slug,
    date: data.date || '',
    excerpt: data.excerpt || '',
    featured_image: data.featured_image || null,
    content
  };
}

// Get all posts sorted by date (newest first)
export function getAllPosts() {
  const posts = Object.entries(postFiles).map(([path, content]) => 
    parsePost(path, content)
  );
  
  return posts.sort((a, b) => new Date(b.date) - new Date(a.date));
}

// Get a single post by slug
export function getPostBySlug(slug) {
  const posts = getAllPosts();
  return posts.find(post => post.slug === slug) || null;
}

// Get latest N posts
export function getLatestPosts(count = 3) {
  return getAllPosts().slice(0, count);
}
